import { signal } from '@preact/signals-react'

export const isEmptyAmazonReleaseDate = signal(false)
export const amazonReleaseDateReportFormIsOpen = signal(false)
export const amazonReleaseDateSubmittedFilters = signal({})